require('./crop.less')

window.enhancer = window.enhancer || {};
var crop;

enhancer.setImage = function (src) {
  $('.container').croppie('destroy');
  crop = $('.container').croppie({
    viewport: {
      width: 150,
      height: 150,
      type: 'square'
    },
    boundary: {
      width: 300,
      height: 300
    }
  });
  crop.croppie('bind', {
      url: src
  });
}



$('.btn-choose').click( function (e) {
  e.preventDefault();
  $('.change-image').click();
});
$('.change-image').on('change', function (e) {
  var files = e.target.files;
  if (!crop) {
    return;
  }
  [].forEach.call(files, function (item) {
      if (item.type.match('image.*')) {
          var src = URL.createObjectURL(item);
          crop.croppie('bind', {
              url: src
          });
      }
  });
});

$('.btn-confirm').click( function (e) {
  e.preventDefault();

  if (crop) {
    var en = window.parent.enhancer;
    if (en && en.setAvatar) {
      crop.croppie('result','canvas').then( function (resp) {
        en.setAvatar(resp);
      });
    }
  }
});


// WEBPACK FOOTER //
// ./src/pages/crop/crop.js